export const PRO_MARKETING_BASE = 'https://www.rintintin-pro.com';

/** Canonical path aligné sitemap / Pretty URL Netlify (slash final sauf fichiers statiques). */
export function normalizeMarketingPathForCanonical(pathname: string): string {
  const pathOnly = String(pathname).split('?')[0].split('#')[0];
  if (!pathOnly || pathOnly === '/') return '/';
  const path = pathOnly.startsWith('/') ? pathOnly : `/${pathOnly}`;
  const trimmed = path.replace(/\/+$/, '') || '/';
  if (trimmed === '/') return '/';
  if (/\.[a-z0-9]{2,5}$/i.test(trimmed)) return trimmed;
  return `${trimmed}/`;
}

export function marketingCanonicalUrl(pathname: string, explicitPath?: string): string {
  const path = normalizeMarketingPathForCanonical(explicitPath ?? pathname);
  return path === '/' ? `${PRO_MARKETING_BASE}/` : `${PRO_MARKETING_BASE}${path}`;
}

/** Liens internes marketing (React Router) — slash final aligné sitemap / Pretty URL. */
export function proMarketingHref(path: string): string {
  return normalizeMarketingPathForCanonical(path);
}

/** Routes app (pas de slash final dans le routeur SPA). */
const APP_INTERNAL_PATHS_NO_TRAILING_SLASH = new Set([
  '/login',
  '/signup-user',
  '/signup-professional',
  '/signup-pro',
  '/signup',
  '/app',
]);

/**
 * Href interne rendu (Link / <a>) — slash final sur le path, sans toucher query, ancres /#…,
 * mailto/tel, http(s) ni extensions de fichier.
 */
export function proMarketingInternalHref(href: string): string {
  const raw = String(href ?? '');
  if (!raw || !raw.startsWith('/')) return raw;
  if (raw.startsWith('/#')) return raw;

  const hashIdx = raw.indexOf('#');
  const beforeHash = hashIdx >= 0 ? raw.slice(0, hashIdx) : raw;
  const hash = hashIdx >= 0 ? raw.slice(hashIdx) : '';

  const queryIdx = beforeHash.indexOf('?');
  const pathOnly = queryIdx >= 0 ? beforeHash.slice(0, queryIdx) : beforeHash;
  const query = queryIdx >= 0 ? beforeHash.slice(queryIdx) : '';

  if (APP_INTERNAL_PATHS_NO_TRAILING_SLASH.has(pathOnly)) return raw;

  const normalized = normalizeMarketingPathForCanonical(pathOnly);
  return `${normalized}${query}${hash}`;
}

/** true si href interne marketing doit finir par / (pour assertions QA). */
export function internalMarketingHrefMissingTrailingSlash(href: string | null | undefined): boolean {
  if (!href) return false;
  if (/^(https?:|mailto:|tel:)/i.test(href)) return false;
  if (href.startsWith('#') || href.startsWith('/#')) return false;
  if (!href.startsWith('/')) return false;
  if (href.includes('?')) return false;

  const pathPart = href.split('#')[0].split('?')[0];
  if (pathPart === '/') return false;
  if (/\.[a-z0-9]{2,5}$/i.test(pathPart)) return false;
  return !pathPart.endsWith('/');
}
